import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CropImageMixin extends Vue {
  protected crop(imageSource: string, width: number, height: number) {
    return `${imageSource}?w=${width}&h=${height}&fit=crop`;
  }
}
